import { render, staticRenderFns } from "./TagFlag.vue?vue&type=template&id=6d5fdfe7&scoped=true"
import script from "./TagFlag.vue?vue&type=script&lang=js"
export * from "./TagFlag.vue?vue&type=script&lang=js"
import style0 from "./TagFlag.vue?vue&type=style&index=0&id=6d5fdfe7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5fdfe7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d5fdfe7')) {
      api.createRecord('6d5fdfe7', component.options)
    } else {
      api.reload('6d5fdfe7', component.options)
    }
    module.hot.accept("./TagFlag.vue?vue&type=template&id=6d5fdfe7&scoped=true", function () {
      api.rerender('6d5fdfe7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tag/TagFlag.vue"
export default component.exports